import React, {useContext, useEffect, useState} from 'react';
import './MainBuyFactor.scss';
import BuyFactorKol from "./BuyFactorKolAndJoz/BuyFactorKol";
import BuyFactorJoz from "./BuyFactorKolAndJoz/BuyFactorJoz";
import {prefixUrl} from "../../../utils/utilsData";
import _axios from "../../../httpService";
import Loader from "../../Loader";
import {toast} from "react-toastify";
import {useLocation, useNavigate} from "react-router-dom";
import useTitle from "../../Hooks/useTitle";
import {SetPrintDataContext} from "../../../Pages";

const MainBuyFactor = () => {
  //http://localhost:3000/Operation/1-m
  const location = useLocation();
  const setPrint = useContext(SetPrintDataContext);
  let navigate = useNavigate();
  useTitle("فاکتور خرید");
  const navigateTo = useNavigate();
  const [initialData, setInitialData] = useState({})
  const [sendData, setSendData] = useState({
    mode: "",
    id: "",
    date: "",
    factorNumber: "",
    paymentType: "fund",
    fundId: "",
    fundName: "",
    bankId: "",
    bankName: "",
    sellerId: "",
    sellerName: "",
    serviceTitle: "",
    servicePrice: "",
    totalDiscount: "",
    tax: "",
    fundPrice: "",
    bankPrice: "",
    tableData: [],
  })
  const [isLoad, setIsLoad] = useState(false)
  const [totalPrice, setTotalPrice] = useState({
    sumTable: 0,
    sumFactor: 0,
  })

  useEffect(() => {
    if (location?.state?.mode === "edit") {
      setSendData({...sendData, mode: "edit", id: location?.state?.id})
    } else {
      setSendData({...sendData, mode: "add"})
    }
  }, [location]);

  useEffect(() => {
    if (sendData.mode === "edit") {
      const fetchEditData = async () => {
        try {
          const url = prefixUrl() + '/buyFactor/?request=factorSubmitedData&id=' + sendData.id
          const res = await _axios.get(url)
          if (res.data.status) {
            return res.data
          } else {
            toast.error(res.data.message)
          }
        } catch (error) {
          return {status: false}
        }
      }

      fetchEditData().then(result => {
        if (result) {
          let temp = {...result?.data}
          temp.tableData.forEach((v) => {
            v.unicId = Math.random() * 1300
          })
          setSendData(temp);
        } else {
          setIsLoad(false)
        }
      }).catch(error => {
        console.error('Error in fetchData promise:', error);
      });
    }
  }, [sendData.mode]);

  useEffect(() => {
    setIsLoad(false)
    const fetchData = async () => {
      try {
        const url = prefixUrl() + '/buyFactor/?request=initialData'
        const res = await _axios.get(url)
        if (res.data.status) {
          return res.data
        } else {
          toast.error(res.data.message)
        }
      } catch (error) {
        return {status: false}
      }
    }

    fetchData().then(result => {
      if (result) {
        setIsLoad(true)
        setInitialData(result);
      } else {
        setIsLoad(false)
      }
    }).catch(error => {
      console.error('Error in fetchData promise:', error);
    });

  }, []);

  useEffect(() => {
    if (isLoad) {
      setSendData({...sendData, bankId: "", fundId: "", sellerId: "", fundName: "", bankName: "", sellerName: "",})
    }
  }, [sendData?.paymentType]);

  useEffect(() => {

    let totalTable = 0
    let totalFactor

    if (sendData.tableData.length > 0) {
      sendData.tableData.forEach((v) => {
        totalTable = totalTable + ((+v.price - +v.discount) * +v.number)
      })
    }
    const tax = (((totalTable + +sendData?.servicePrice) - +sendData?.totalDiscount) * sendData?.tax) / 100
    totalFactor = ((totalTable + +sendData?.servicePrice) - +sendData?.totalDiscount) + tax

    setTotalPrice({sumFactor: totalFactor, sumTable: totalTable})
  }, [sendData]);

  const onSubmitForm = async (submitType) => {

    if (sendData?.factorNumber === "") {
      return toast.error("شماره فاکتور را وارد کنید.")
    }

    if (sendData?.date === "") {
      return toast.error("تاریخ را وارد کنید.")
    }

    if (sendData?.tableData.length === 0) {
      return toast.error("کالا را وارد کنید.")
    }

    let codeArray = [];
    sendData.tableData.forEach((v) => {
      if (v?.number === "1") {
        codeArray.push(v?.productId)
      } else {
        let i = 0
        while (i < +v?.number) {
          codeArray.push(v?.productId)
          i = i + 1
        }
      }

    })

    const obj = {request: "factorConfirm", data: sendData}
    const response = await _axios.post(prefixUrl() + "/buyFactor/", obj)

    if (response?.data?.status) {
      toast.success(response.data.message)
      if (submitType === "Print") {
        const CodesArrayFormData = new FormData();
        CodesArrayFormData.append("id", `[${codeArray}]`);
        CodesArrayFormData.append("type", "id");
        CodesArrayFormData.append("request", "barcodeData");

        const responsePrint = await _axios.post(prefixUrl() + "/barcode/", CodesArrayFormData)
        if (responsePrint.data.status) {
          responsePrint.data.type = "BarcodeDataPrint";
          const sendData = {
            type: responsePrint.data.type, data: responsePrint.data,
          };
          setPrint(sendData);
          navigate("/factorprint");
        } else {
          toast.error(responsePrint?.data?.message)
        }
      } else {
        if (sendData?.mode === "edit") {
          return navigateTo(-1)
        }
        setSendData({
          mode: "add",
          id: "",
          date: "",
          factorNumber: "",
          paymentType: "fund",
          fundId: "",
          fundName: "",
          bankId: "",
          bankName: "",
          sellerId: "",
          sellerName: "",
          serviceTitle: "",
          servicePrice: "",
          totalDiscount: "",
          tax: "",
          fundPrice: "",
          bankPrice: "",
          tableData: [],
        })
      }
    } else {
      toast.error(response.data.message)
    }
  }

  try {
    return (
      <>
        {isLoad ?
          <div className="mbf-13">
            <BuyFactorKol initialData={initialData}
                          setSendData={setSendData}
                          sendData={sendData}
                          onSubmitForm={onSubmitForm}
                          totalPrice={totalPrice}/>

            <BuyFactorJoz initialData={initialData}
                          setSendData={setSendData}
                          sendData={sendData}
                          totalPrice={totalPrice}/>
          </div> :
          <div className={"loader-pos"}><Loader/></div>}
      </>
    );

  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default React.memo(MainBuyFactor);